import { RootState } from "@/redux/store";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import useDocumentTitle from "@/components/ui/common/document-title";
import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import InvoiceReminderWorkflow from "./table/invoice-reminder-workflow";
import MyBusiness from "./table/my-business";
import MembershipExpiry from "./table/membership-expiry";
import PushNotification from "./table/push-notification";
import EmailTemplate from "./table/email-template";

interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
}
const SystemConfiguration: React.FC = () => {
  useDocumentTitle("System Configuration");

  const [activeTab, setActiveTab] = useState("my-business");

  const tabs: Tab[] = [
    {
      id: "my-business",
      label: "My Business",
      content: <MyBusiness />,
    },
    {
      id: "invoice-reminder",
      label: "Invoice Reminder",
      content: <InvoiceReminderWorkflow />,
    },
    {
      id: "membership-expiry",
      label: "Membership Expiry Reminder",
      content: <MembershipExpiry />,
    },
    {
      id: "notifications",
      label: "Push Notifications",
      content: <PushNotification />,
    },
    // {
    //   id: "email-template",
    //   label: "Email Templates",
    //   content: <EmailTemplate />,
    // },
  ];

  return (
    <div className="w-full p-5">
      <Card className="pt-4">
        <h1 className="text- font-semibold mx-6 ">Settings</h1>
        <Separator className="h-[1px] w-[calc(100%-36px)] mx-auto" />
        <div className="relative top-0 grid grid-cols-2 lg:grid-cols-4 gap-4 p-4">
          {/* Vertical Tabs - Takes up 1 column in desktop*/}
          <div className="lg:sticky lg:top-[12%] col-span-2 lg:col-span-1   px-1 py-2 space-y-1.5 bg-gray-200 rounded-lg  flex flex-col items-center h-fit">
            {tabs.map((tab) => (
              <Button
                key={tab.id}
                variant={activeTab === tab.id ? "secondary" : "ghost"}
                className={cn(
                  "font-normal h-9 w-[calc(100%-14px)] p-2 justify-start space-x-1 text-left text-sm  text-gray-500",
                  activeTab === tab.id && "text-black  px-2 py-0"
                )}
                onClick={() => setActiveTab(tab.id)}
              >
                <span
                  className={cn(
                    "rounded-full p-[3px] bg-gray-400",
                    activeTab === tab.id && " bg-primary"
                  )}
                ></span>
                <span className="text-sm">{tab.label}</span>
              </Button>
            ))}
          </div>

          {/* Content Area - Takes up 2 columns in desktop*/}
          <div className="col-span-2 lg:col-span-3">
            {tabs.find((tab) => tab.id === activeTab)?.content}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SystemConfiguration;
